<template>
    <div>
        <div v-show="parentShow">
            <Form :model="formItem" :label-width="80" inline>
                <Form-item label="昵称">
                    <Input type="text" v-model="formItem.nickname"></Input>
                </Form-item>
                <Form-item label="真实姓名">
                    <Input type="text" v-model="formItem.realname"></Input>
                </Form-item>
                <Form-item label="手机号码">
                    <Input type="text" v-model="formItem.phone"></Input>
                </Form-item>
                <Form-item label="状态">
                    <Select v-model="formItem.status" style="width:200px">
                        <Option v-for="item in selData" :value="item.val" :key="item.val">{{item.name}}</Option>
                    </Select>
                </Form-item>
                <Form-item>
                    <Button type="primary" @click="init">查询</Button>
                </Form-item>
                <Form-item>
                    <Button type="primary" @click="addFn()">创建用户</Button>
                </Form-item>
            </Form>
            <Table border :columns="columns" :data="data"></Table>
            <div class="clearfix page">
                <Page :total="pageTotal" class="fr" @on-change="pageChange" @on-page-size-change="pageSize" :current="formItem.start+1" placement="top" show-elevator show-sizer></Page>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    export default {
        data(){
            return{
                formItem: {
                    nickname:null,
                    realname:null,
                    phone:null,
                    status:null,
                    start:0,
                    length:10,
                },
                selData:[
                    {
                        val:10,
                        name:'全部'
                    },{
                        val:0,
                        name:'正常'
                    },{
                        val:1,
                        name:'删除'
                    }
                ],
                columns:[
                    {
                        title: '用户昵称',
                        key: 'nickname'
                    },{
                        title: '真实姓名',
                        key: 'realname'
                    },{
                        title: '手机号',
                        key: 'userphone'
                    },{
                        title: '创建时间',
                        key: 'cdate'
                    },{
                        title: '用户状态',
                        key: 'statusStr'
                    },{
                        title: '操作',
                        width: 230,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    on:{
                                        click:() => {
                                            this.seeFn(params.row.uid);
                                        }
                                    }
                                }, '查看'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{
                                        display:params.row.statusStr == '删除' ? 'none' : 'inline-block'
                                    },
                                    on: {
                                        click: () => {
                                            this.modifyFn(params.row.uid);
                                        }
                                    }
                                }, '修改'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{
                                        display:params.row.statusStr == '删除' ? 'none' : 'inline-block'
                                    },
                                    on: {
                                        click: () => {
                                            var _this=this;
                                            this.$Modal.confirm({
                                                content: '确认要删除吗？',
                                                onOk(){
                                                    _this.remove(params.row.uid);
                                                },
                                            });
                                        }
                                    }
                                }, '删除'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{
                                        display:params.row.statusStr == '删除' ? 'none' : 'inline-block'
                                    },
                                    on: {
                                        click: () => {
                                            this.passRightFn(params.row.uid);
                                        }
                                    }
                                }, '修改密码')
                            ]);
                        }
                    }
                ],
                data:[],
                pageTotal:0,
            }
        },
        watch:{
            $route(to,from){
                if(to.path == '/rightsApp'){
                    this.$store.dispatch('parentShowFn');
                    this.getData();
                };
            }
        },
        computed: {
            parentShow () {
                return this.$store.state.parentShow;
            }
        },
        created(){
            this.getData();
            this.$store.dispatch('parentShowFn');
        },
        methods:{
            getData(){      //列表数据
                var _this=this;
                this.$http.get('/web/user/getUserList',{
                    params:_this.formItem
                }).then(function(res){
                    _this.data=res.data;
                    _this.pageTotal=res.recordsTotal;
                    _this.$Message.success('加载成功');
                }).catch(function(res){
                    _this.$Message.error('加载失败');
                })
            },
            passRightFn(id){   //修改密码
                this.$router.push({path:'/rightsApp/passRight',query:{uid:id}});
            },
            modifyFn(id){   //修改
                this.$router.push({path:'/rightsApp/modifyRight',query:{uid:id}});
            },
            seeFn(id){      //查看
                this.$router.push({path:'/rightsApp/seeRight',query:{uid:id}});
            },
            addFn(){        //添加
                this.$router.push({path:'/rightsApp/addRight'});
            },
            remove(id){     //删除
                var _this=this;
                this.$http.get('/web/user/deleteUser',{
                    params:{
                        uid:id
                    }
                }).then(function(res){
                    if(res.success){
                        _this.$Notice.success({
                            title: '删除用户',
                            desc: res.message,
                        });
                        _this.getData();
                    }else{
                        _this.$Notice.error({
                            title: '删除用户',
                            desc: res.message,
                        });
                    }
                }).catch(function(res){
                    _this.$Notice.error({
                        title: '删除用户',
                        desc: '表单提交失败',
                    });
                })
            },
            pageChange(res){    //分页
                this.formItem.start=res-1;
                this.getData();
            },
            pageSize(res){  
                this.formItem.length=res;
                this.getData();
            },
            init(){
                this.formItem.start=0;
                this.getData();
            },
        }
    }
</script>
<style scoped>
     .vertical-center-modal{
        display: flex;
        align-items: center;
        justify-content: center;

    }
    .ivu-modal{
        top: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/rightsApp/Right.vue